import Context from './context'
import DfsCursor from './dfs-cursor'
import Flags from './flags'
import Stack from './stack'
import { isNotEmpty } from './util'

/**
 * This code is orginally from tree-crawl - https://github.com/ngryman/tree-crawl
 * I added it here, because I had weird resolving issues with it and that was a quick fix.
 */
export default function dfsPre(
  root: TODOAny,
  iteratee: TODOAny,
  { getChildren }: TODOAny
) {
  const flags = Flags()
  const cursor = DfsCursor()
  const context = Context(flags, cursor)
  const stack = Stack(root)

  // perf: use same hidden class than root node in order to
  // keep the stack monomorphic
  const dummy = { ...root }

  while (!stack.isEmpty()) {
    let node = stack.pop()

    if (node === dummy) {
      cursor.moveUp()
    } else if (node == null) {
      continue
    } else {
      flags.reset()

      iteratee(node, context)

      if (flags.break) {
        break
      }
      if (!flags.remove) {
        cursor.moveNext()

        if (!flags.skip) {
          if (flags.replace) {
            node = flags.replace
          }

          const children = getChildren(node)
          if (isNotEmpty(children)) {
            stack.push(dummy)
            stack.pushArrayReverse(children)
            cursor.moveDown(node)
          }
        }
      }
    }
  }
}
